import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getAppointmentAnalyses, 
  getAppointmentAnalysis, 
  clearLocalAppointmentAnalyses, 
  clearLocalActiveAppointmentAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  appointmentAnalysis: { 
    id: '', 
    input: '', 
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false,  
    appointmentAnalysis: false
  }
};

const slice = createSlice({
  name: 'appointmentAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getAppointmentAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getAppointmentAnalyses.fulfilled, (state, action) => {
        const { appointment_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...appointment_analyses], 'id');

        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getAppointmentAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getAppointmentAnalysis.pending, (state) => {
        state.loading.appointmentAnalysis = true;
      })
      .addCase(getAppointmentAnalysis.fulfilled, (state, action) => {
        const { data: { appointment_analysis }, cable } = action.payload;
        const foundedAppointmentAnalysis = !!_find(state.all.data, (s) => s.id === appointment_analysis.id);
        const updatedAppointmentAnalysis = { ...state.appointmentAnalysis, ...appointment_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedAppointmentAnalysis ? _map(state.all.data, (e) => e.id === appointment_analysis.id ? { ...e, ...appointment_analysis } : e) : [...[appointment_analysis], ...oldAllData]; 
        const pagination = foundedAppointmentAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.appointmentAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedAppointmentAnalysis && !cable) state.appointmentAnalysis = updatedAppointmentAnalysis;       
      })
      .addCase(getAppointmentAnalysis.rejected, (state) => {
        state.loading.appointmentAnalysis = false;
      })
      .addCase(clearLocalAppointmentAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveAppointmentAnalysis, state => {
        state.appointmentAnalysis = initialState.appointmentAnalysis;
      })
  }
})

export default slice.reducer;